import type { NDateLocale } from './enUS'
import { arDZ } from 'date-fns/locale'

const dateArDZ: NDateLocale = {
  name: 'ar-DZ',
  locale: arDZ
}

export default dateArDZ
